import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { frappeApi } from '../services/frappeApi';
import '../styles/ProjectList.css';

const ProjectList = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const publicUrl = process.env.PUBLIC_URL || '';

  // Static fallback projects (same as in Projects component)
  const staticProjects = [
    {
      image: `${publicUrl}/images/hosting-erpnext.webp`,
      title: 'Hosting ERPNext',
      description: 'Profesjonalny hosting i zarządzanie instancjami ERPNext w chmurze, zapewniający wysoką dostępność i bezpieczeństwo danych.',
      tech: ['Frappe', 'Python', 'Docker'],
      links: { live: 'https://hosting.erptech.cloud' },
      route: 'hosting-erpnext'
    },
    {
      image: `${publicUrl}/images/ulszkolna.webp`,
      title: 'ulSzkolna.pl',
      description: 'Był to jeden z projektów stworzonych dla uczniów, oferujący zasoby edukacyjne i narzędzia do nauki online.',
      tech: ['Vue.js', 'TypeScript', 'Discord Management'],
      links: null,
      route: 'ulszkolna'
    },
    {
      image: `${publicUrl}/images/litty-dashboard.webp`,
      title: 'Litty',
      description: 'Platforma komunikacyjna w czasie rzeczywistym umożliwiająca tworzenie serwerów społecznościowych, czaty, zarządzanie znajomymi.',
      tech: ['Vue.js', 'TypeScript', 'PostgreSQL', 'Chart.js'],
      links: { live: 'https://litty.pl', code: 'https://github.com/LittyProject' },
      route: 'litty'
    }
  ];

  useEffect(() => {
    // Update page title
    document.title = 'Projekty - Mespi.dev';
  }, []);

  useEffect(() => {
    const fetchProjects = async () => {
      setLoading(true);
      try {
        const blogPosts = await frappeApi.getBlogPosts();
        
        if (blogPosts && blogPosts.length > 0) {
          // Map blog posts to project format
          const mappedProjects = blogPosts.map(post => ({
            title: post.title,
            description: post.blog_intro || '',
            image: post.meta_image || `${publicUrl}/images/default-project.webp`,
            route: post.name,
            tech: post.tech ? post.tech.split(',').map(t => t.trim()) : [],
            published_on: post.published_on,
            name: post.name
          }));
          setProjects(mappedProjects);
        } else {
          // Use static projects as fallback
          setProjects(staticProjects);
        }
      } catch (error) {
        console.error('Error loading projects:', error);
        setProjects(staticProjects);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <Navigation />
      <section className="project-list-section">
        <div className="container">
          <div className="page-header">
            <h1 className="page-title">Nasze Projekty</h1>
            <p className="page-description">
              Portfolio naszych najlepszych realizacji. Każdy projekt to unikalne wyzwanie,
              które podejmujemy z pasją i zaangażowaniem.
            </p>
          </div>

          {loading ? (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p>Ładowanie projektów...</p>
            </div>
          ) : (
            <div className="projects-grid-page">
              {projects.map((project, index) => (
                <Link 
                  to={`/projekty/${project.route || project.name}`} 
                  key={index} 
                  className="project-card-link"
                >
                  <div className="project-card-page">
                    <div className="project-image-wrapper">
                      <img 
                        src={project.image} 
                        alt={project.title}
                        onError={(e) => {
                          e.target.src = `${publicUrl}/images/default-project.webp`;
                        }}
                      />
                    </div>
                    <div className="project-info">
                      <h3 className="project-title">{project.title}</h3>
                      <p className="project-description">{project.description}</p>
                      {project.tech && (
                        <div className="project-tech">
                          {project.tech.map((tech, i) => (
                            <span key={i} className="tech-badge">{tech}</span>
                          ))}
                        </div>
                      )}
                      {project.published_on && (
                        <div className="project-date">
                          {new Date(project.published_on).toLocaleDateString('pl-PL', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ProjectList;
